<template>
  <div
    v-cdrag.parent
    v-cdrag.self
    :style="{ width: width + 2 + 'px', height: height + 2 + 'px' }"
    class="magnify-container"
  >
    <canvas :id="'magnifyCanvas_' + bookId" :width="width" :height="height" />
  </div>
</template>
<script>
import { getImageObject } from "@/services/bookData.js";
export default {
  props: {
    magRatio: {
      default: 2,
    },
    imageRatio: {
      default: 1.0,
    },
    width: {
      default: 200,
    },
    height: {
      default: 200,
    },
    bookId: {
      default: 0,
    },
    page: { default: 0 },
    magnifyPosition: { x: 0, y: 0 },
    marginLeft: { default: 0 },
  },
  data() {
    return {
      fullSizeImg: null,
      ctx: null,
    };
  },
  watch: {
    magnifyPosition(val) {
      //calc image part to magnify
      if (!this.fullSizeImg) return;
      this.drawMagnify();
    },
    page(val) {
      this.drawMagnify(true, val);
    },
  },
  computed: {
    partWidth() {
      return this.width / parseFloat(this.magRatio);
    },
    partHeight() {
      return this.height / parseFloat(this.magRatio);
    },
    lMargin() {
      return (this.width - this.partWidth) / 2;
    },
    tMargin() {
      return (this.height - this.partHeight) / 2;
    },
  },
  methods: {
    async drawMagnify(loadImage = false, page = null) {
      let canvas = document.getElementById("magnifyCanvas_" + this.bookId);
      if (!canvas) return;
      if (this.bookId > 0 && this.page !== 0) {
        //get image in origin size

        if (loadImage || !this.fullSizeImg) {
          this.fullSizeImg = await getImageObject(
            this.bookId,
            page || this.page
          );
          if (!this.fullSizeImg) return;
          this.ctx = canvas.getContext("2d");
        }
        if (!this.fullSizeImg) return;
        const rat = parseFloat(this.imageRatio);

        let middlePoint = {
          x:
            this.magnifyPosition.x +
            this.lMargin -
            parseFloat(this.marginLeft) -
            10 +
            this.partWidth / 2,
          y: this.magnifyPosition.y + this.tMargin - 20 + this.partHeight / 2,
        };
        if (middlePoint.x < 0 || middlePoint.y < 0) return;

        let cropPosition = {
          x: middlePoint.x * rat - (this.partWidth / 2) * rat,
          y: middlePoint.y * rat - (this.partHeight / 2) * rat,
        };
        if (cropPosition.x < 0) cropPosition.x = 0;
        if (cropPosition.y < 0) cropPosition.y = 0;
        this.ctx.drawImage(
          this.fullSizeImg.picture,
          cropPosition.x,
          cropPosition.y,
          this.partWidth * rat,
          this.partHeight * rat,
          0,
          0,
          this.width,
          this.height
        );
      }
    },
  },
  async mounted() {
    this.drawMagnify();
  },
  destroyed() {
    this.fullSizeImg = null;
  },
};
</script>

<style lang="scss" scoped>
.magnify-container {
  position: absolute;
  top: 40px;
  left: 10px;
  z-index: 9999;
  cursor: zoom-in;
  border: black 1px solid;
}
</style>
